import { gtagEnabled } from './index'
import { formatMedusaPrice } from '../formatMedusaPrice'
import { PricedVariant } from '@medusajs/medusa/dist/types/pricing'

export const trackViewItem = (variant: PricedVariant) => {
    if (gtagEnabled()) {
        gtag('event', 'view_item', {
            currency: 'EUR',
            value: formatMedusaPrice(variant.prices[0].amount),
            items: {
                item_name: variant.title,
                item_id: variant.id,
                price: formatMedusaPrice(variant.prices[0].amount),
            },
        })
    }
}
